import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { NO_SCROLL_CLASS_NAME } from '../classnames/design-system';
import { ACTIVE_CLASS_NAME as ACTIVE_POPUP_CLASS } from '../navigation/side-menu';
import { getPageQueryParams } from '../utils/get-page-url';

gsap.registerPlugin(ScrollToPlugin);

export default class AnchorLinksHandler {
  initialize = () => {
    const { scrollTo, scrollOffset } = getPageQueryParams() || {};
    const scrollTargetID = `#${scrollTo}`;

    if (document.getElementById(scrollTo)) {
      setTimeout(() => {
        this.handleSmoothScroll(scrollTargetID, scrollOffset);
      }, 500);
    }

    const links = document.getElementsByTagName('a');
    [...links].forEach((link) => {
      if (
        link.href
        && link.href.indexOf('#') !== -1
        && link.href.indexOf('#') !== link.href.length - 1
        && (link.pathname === window.location.pathname
          || `/${link.pathname}` === window.location.pathname)
        && link.search === window.location.search
      ) {
        link.addEventListener('click', this.scrollAnchors);
      }
    });
  };

  scrollComplete = (targetID) => () => window.history.pushState('', '', targetID);

  handleSmoothScroll = (targetID, scrollOffset) => {
    gsap.to(
      window,
      {
        duration: 1,
        scrollTo: { y: targetID, offsetY: scrollOffset || 0 },
        onComplete: this.scrollComplete(targetID)
      }
    );
  };

  scrollAnchors = (e) => {
    e.preventDefault();

    const activePopupElement = document.querySelector(`.${ACTIVE_POPUP_CLASS}`);

    if (activePopupElement) {
      activePopupElement.classList.remove(ACTIVE_POPUP_CLASS);
      document.body.classList.remove(NO_SCROLL_CLASS_NAME);
    }

    const { currentTarget } = e;
    const targetID = currentTarget.getAttribute('href');
    const { scrollOffset } = currentTarget.dataset;

    if (document.querySelector(targetID)) {
      this.handleSmoothScroll(targetID, scrollOffset);
    }
  };
}
